import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { setToken } from "../utils/auth";
import "./UserLogin.css";
import configData from "../config.json";
import Loading from "../Loading/Loading";
import { handleGoogleLogin, handleAppleLogin, handleMicrosoftLogin, handleUsernamePasswordLogin } from "../utils/loginOptions";
import { FcGoogle } from "react-icons/fc";
import { FaApple } from "react-icons/fa";
import { FaMicrosoft } from "react-icons/fa";

const UserLogIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loginLoading, setLoginLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (idToken) => {

    try {
      if (!idToken) throw new Error("Authentication failed");

      const response = await fetch(
        `${configData.SERVER_URL}/Authentication/Login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`
          }
        }
      );

      const data = await response.json();
      if (response.status === 200) {

        const token = data.token;
        const expISO = data.exp;

        const expirationDate = new Date(expISO);
        const expiresInSeconds = Math.floor(
          (expirationDate.getTime() - Date.now()) / 1000
        );

        if (expiresInSeconds <= 0) {
          throw new Error("Token already expired");
        }

        // Store token with expiration time
        setToken(token, expiresInSeconds);

        navigate("/platform-selection");
      }
      else if (data.status === 403) {
        throw new Error("Access forbidden: user not authorized");
      }
      else if (data.status === 401) {
        throw new Error("Invalid Username or Password");
      }
      else {
        throw new Error(data?.message || "Unknown server response");
      }

    } catch (error) {
      console.error(error.message);
      setError(error.message);
      setLoginLoading(false);
    }
  };


  const handleEmailPasswordSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoginLoading(true);

    try {
      const idToken = await handleUsernamePasswordLogin(email, password);
      await handleLogin(idToken);
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoginLoading(false);
    }
  };

  const handleProviderLogin = async (providerFn) => {
    setError(null);
    setLoginLoading(true);

    try {
      const idToken = await providerFn();
      await handleLogin(idToken);
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <div className="login-container">
      {loginLoading ? (
        <Loading />
      ) : (
        <div className="login-form">
          <div className="login-header">
            <img src="/favicon.ico" alt="Flavi Icon" />
          </div>

          <h1>Catch Field</h1>

          {error && (
            <div className="login-error-message" role="alert">
              {error}
            </div>
          )}

          <form onSubmit={handleEmailPasswordSubmit}>
            <div className="input-group">
              <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field"
              />
            </div>

            <div className="input-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-field"
              />
            </div>

            <button type="submit" className="login-btn">
              Login
            </button>
          </form>
          {/* Social logins – SAME CSS */}
          <div className="provider-icons">
            <FcGoogle
              className="clickable-icon"
              onClick={() => handleProviderLogin(handleGoogleLogin)}
            />
            <FaApple
              className="clickable-icon"
              onClick={() => handleProviderLogin(handleAppleLogin)}
            />
            <FaMicrosoft
              className="clickable-icon"
              onClick={() => handleProviderLogin(handleMicrosoftLogin)}
            />
          </div>


        </div>
      )}
    </div>
  );

};

export default UserLogIn;